import React, { useEffect, useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import { api } from '../app/Api/ApiSlice';
import Loader from './Loader';
import { toast } from 'react-toastify';

const CartSelector = ({ isOpen, onClose, selectedProduct, quantity,storeName }) => {

    const [carts, setCarts] = useState([]);
    const [loadingCarts, setLoadingCarts] = useState(false);
    const [selectedCart, setSelectedCart] = useState('');
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [cartName, setCartName] = useState('');


    useEffect(() => {
        if (isOpen) {
            fetchCarts();
        }
    }, [isOpen]);

    const fetchCarts = async () => {
        setLoadingCarts(true);
        try {
            const response = await api.get(`/stores/${storeName}/carts`);
            setCarts(response.data);
        } catch (error) {
            console.error('Error fetching carts:', error);
            toast.error('Failed to load carts');
        } finally {
            setLoadingCarts(false);
        }
    };

    const handleSubmit = async () => {
        if (!selectedCart) {
            toast.error('Please select a cart first');
            return;
        }

        setLoadingSubmit(true);
        try {
            const addedProduct = {
                selectedCart,
                selectedProduct,
                quantity:quantity || 1,
            };

            await api.patch(`/stores/${storeName}/carts/${selectedCart}/add`, addedProduct);
            toast.success('Product added to cart');
            onClose();
        } catch (error) {
            toast.error(error.response.data.message);
        } finally {
            setLoadingSubmit(false);
        }
    };

    const createCart = async () => {
        if (!cartName.trim()) {
            toast.error('Cart name is required');
            return;
        }

        setLoadingSubmit(true);
        try {
            const newCart = {
                cartName,
                products: [{id:selectedProduct,quantity}],
            };

            const response = await api.post(`/stores/${storeName}/carts`, newCart);
            toast.success(response.data.message || 'Cart created');
            setCartName('');
            fetchCarts();
            onClose()
        } catch (error) {
            console.error(error);
            toast.error(error.response?.data?.message || 'Error creating cart');
        } finally {
            setLoadingSubmit(false);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="open-cart-selector">
            <div className="close-modal-btn">
                <FaTimes onClick={onClose} />
            </div>

            {loadingCarts ? (
                <Loader />
            ) : (
                <div>
                    <h1>select a cart</h1>

                    {carts.length === 0 ? (
                        <p>No carts available</p>
                    ) : (
                        <ul className='carts-selector-list'>
                            {carts.map((cart) => (
                                <li
                                    key={cart._id}
                                    onClick={() => setSelectedCart(cart._id)}
                                >
                                    <div
                                        className={`cart-select-wrapper ${
                                            selectedCart === cart._id ? 'selected' : ''
                                        }`}
                                        onClick={handleSubmit}
                                    >
                                        <p><strong>{cart.name}</strong></p>
                                        <p><strong>Items:</strong> {cart.productsCount}</p>
                                        <p><strong>Total:</strong> {cart.total}</p>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}

                    <div className="new-cart">
                        <input
                            type="text"
                            placeholder="name"
                            value={cartName}
                            onChange={(e) => setCartName(e.target.value)}
                        />
                        <button onClick={createCart} disabled={loadingSubmit}>
                            New
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default CartSelector;
